type PostMessageEvent = {
  data: {
    type: string;
    message: string;
  };
};

export const CheckoutCom3ds2Status = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
};

export const CHECKOUT_COM_3DS2_REDIRECT_PAGE_EVENT = {
  TYPE: 'CHECKOUT_COM_3DS2_REDIRECT',
  SUCCESS: '3DS2_SUCCESS',
  FAILED: '3DS2_FAILED',
};

export function confirmCheckoutCom3ds2() {
  return new Promise((resolve) => {
    const handleReceiveMessage = (event: PostMessageEvent) => {
      if (event.data.type === CHECKOUT_COM_3DS2_REDIRECT_PAGE_EVENT.TYPE) {
        if (event.data.message === CHECKOUT_COM_3DS2_REDIRECT_PAGE_EVENT.SUCCESS) {
          resolve(CheckoutCom3ds2Status.SUCCESS);
        }
        if (event.data.message === CHECKOUT_COM_3DS2_REDIRECT_PAGE_EVENT.FAILED) {
          resolve(CheckoutCom3ds2Status.FAILED);
        }
        window.removeEventListener('message', handleReceiveMessage);
      }
    };
    window.addEventListener('message', handleReceiveMessage);
  });
}
